import { useEffect, useState } from "react";
import ClassDocuments from "../ClassDocuments";
import { GetCoursesByClassId } from "../../../actions/teacherQueries";
import { PacmanLoader } from "react-spinners";

export default function TeacherDocuments(props) {
  const coursesData = GetCoursesByClassId(props.classId);

  const [level, setLevel] = useState();

  useEffect(() => {
    setLevel(props.level);
  }, [props.level]);

  if (coursesData.isLoading || !coursesData.data) {
    return (
      <div className="inline-pacman-loader">
        <PacmanLoader color="#20a8d8" size={20} />
      </div>
    );
  }

  const renderLevel = () => {
    switch (level) {
      case "Class":
        return (
          <ClassDocuments
            coursesData={coursesData}
            teacherInfo={props.teacherInfo}
            classId={props.classId}
          />
        );
      case "Student":
        return <div>Student</div>;
      case "Program":
        return <div>Program</div>;
      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
